@if ($cmIconClass()) {
    <i [ngClass]="[$cmIconClass(), 'cm-action-icon']"></i>
}
<ng-content></ng-content>
